import { render, staticRenderFns } from "./index.vue?vue&type=template&id=79dd4e3d"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79dd4e3d')) {
      api.createRecord('79dd4e3d', component.options)
    } else {
      api.reload('79dd4e3d', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=79dd4e3d", function () {
      api.rerender('79dd4e3d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/category-product/index.vue"
export default component.exports